const initialState = {
  loading: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_STATE_DASHBOARD":
      return Object.assign({}, state, {
        [action.propertyName]: action.value,
      });
    case "SET_MULTIPLE_STATE_DASHBOARD":
      return Object.assign({}, state, action.newObject);
    default:
      return state;
  }
}

// set state dashboard
export function setStateDashboard(propertyName, value) {
  return {
    type: "SET_STATE_DASHBOARD",
    propertyName,
    value,
  };
}

// set multi dashboard
export function setMultipleStateDashboard(newObject) {
  return {
    type: "SET_MULTIPLE_STATE_DASHBOARD",
    newObject,
  };
}
